import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import LoaderComponent from "../../Common/LoaderComponent";
import useRequiredFields from "../../../hooks/useRequiredFields";
import IsLogin from "../../Common/IsLogin";
import Alert from "../../Common/Alert";
import Http from "../../Common/Http";
import Select from "react-select";
const Create = () => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({ code: "", decoration_name: "", status: "" });
  const [error, setError] = useState({});
  const [totalAmount, setTotalAmount] = useState(0);
  const [list, setList] = useState([{ purpose: "", amount: "" }]);
  const { checkRequiredFields } = useRequiredFields();
  const [role, setRole] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    const fetchShapeTypes = async () => {
      try {
        const res = await Http.get("/staff-type-check");
        setRole(res.data);
        if (res.data === "sample") {
          setInputs((prev) => ({
            ...prev,
            status: { value: "on_test", label: "On Test" }, // Default status
          }));
        } else {
          setInputs((prev) => ({
            ...prev,
            status: { value: "active", label: "Active" }, // Default status
          }));
        }
      } catch (error) {
        console.error("Error fetching shape types:", error);
      }
    };

    fetchShapeTypes();
  }, []);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };
  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const inputInfo = [...list];
    inputInfo[index][name] = value;
    setList(inputInfo);
  };

  const displayError = (fieldName) => {
    if (error && error[fieldName]) {
      return <div className="text-danger small">{error[fieldName]}</div>;
    }
    return null;
  };

  const handleImageChange = (e) => {
    setSelectedImage(e.target.files[0]);
  };
  let statusOptions = [
      { value: "active", label: "Active" },
      { value: "inactive", label: "Inactive" },
    ];
  const formSubmit = (e) => {
    e.preventDefault();
    const { isValid, error } = checkRequiredFields(inputs);
    if (!isValid) {
      setError(error);
    }
    const formData = new FormData();
    formData.append("image", selectedImage);
    formData.append("code", inputs.code);
    formData.append("decoration_name", inputs.decoration_name);
    formData.append("status", inputs.status.value);
    Http.post("/planning-image", formData)
      .then((res) => {
        console.log(res);
      })
      .then(() => {
        navigate("/planning-image-upload");
      });
  };

  const handleStatusChange = (option) => {
    setInputs((values) => ({ ...values, status: option }));
  };

  return (
    <>
      <IsLogin />
      <div className="am-mainpanel">
        <div className="am-pagetitle g-2">
          <h5 className="am-title">Image Upload</h5>
          <Link to="/planning-image-upload" className="btn btn-primary">
            <i className="fa fa-bars mg-r-6"></i>
            list
          </Link>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <div className="table-wrapper">
              <form onSubmit={formSubmit} className="row">
                <div className="col-lg">
                  <div className="form-group">
                    <label htmlFor="code">
                      Code{" "}
                      <span className="text-danger">
                        <i className="fa fa-star required"></i>
                      </span>{" "}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="code"
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="col-lg">
                  <div className="form-group">
                    <label htmlFor="name">
                      Decoration Name{" "}
                      <span className="text-danger">
                        <i className="fa fa-star required"></i>
                      </span>{" "}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="decoration_name"
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg">
                    <div className="form-group">
                      <label htmlFor="image">
                        Image <span className="text-danger"></span>{" "}
                      </label>
                      <input
                        type="file"
                        className="form-control"
                        name="image"
                        onChange={handleImageChange}
                      />
                    </div>
                  </div>
                  {role !== "sample" && (
                    <div className="col-lg">
                      <div className="form-group">
                        <label htmlFor="image">
                          Status <i className="fa fa-star required"></i>
                        </label>
                        <Select
                          className="basic-single"
                          classNamePrefix="select"
                          name="status"
                          options={statusOptions} // Options for active/inactive
                          value={inputs.status}
                          onChange={handleStatusChange} // Handle status dropdown change
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className="row">
                  <div className="col-lg-2">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Create;
